import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

interface Props {
  onClose: () => void;
}

function TrialBannerForSmallScreens({ onClose }: Props) {
  const classes = useStyles();

  return (
    <Paper className={classes.root} square>
      <div className={classes.content}>
        <Typography variant="h6">Please Read</Typography>
        <Typography>This experience is best on a laptop or desktop. </Typography>
      </div>

      <div className={classes.buttonContainer}>
        <Button className={classes.button} color="secondary" onClick={onClose}>
          Acknowledge
        </Button>
      </div>
    </Paper>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      position: 'absolute',
      bottom: 0,
      zIndex: theme.zIndex.max,
      width: '100%',
      maxHeight: 134,
      padding: theme.spacing(2.5),
      border: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(2),
    },
    buttonContainer: {
      display: 'flex',
    },
    button: {
      marginLeft: 'auto',
      textTransform: 'none',
    },
  };
});

export default TrialBannerForSmallScreens;
